import { IconArrowsDiagonal, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import clsx from 'clsx';
import ImageView, { type DirectScreenshots } from '~/components/browser/implementations/ImageView';

export default function ScreenshotComparisonViewer({
  isOpen,
  leftOperationId,
  rightOperationId,
  onClose,
  rightDirectScreenshotUrl,
  rightDirectScreenshots,
}: {
  isOpen: boolean;
  leftOperationId?: string;
  rightOperationId?: string;
  onClose: () => void;
  rightDirectScreenshotUrl?: string;
  /** Multiple direct screenshot URLs with before/action/after tabs */
  rightDirectScreenshots?: DirectScreenshots;
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={clsx(
        'sticky top-10 z-50 ml-7 flex flex-col overflow-y-auto rounded-xl border-[2px] border-gray-300 bg-white transition-all duration-300 ease-in-out dark:border-stone-600 dark:bg-stone-800',
        isExpanded ? 'h-[60vh]' : 'h-[40vh]',
      )}
    >
      <div className="sticky top-0 z-50 flex items-center justify-between border-b border-gray-300 bg-white px-4 py-2 dark:border-stone-600 dark:bg-stone-800">
        <div className="flex flex-1 justify-around">
          <div className="text-md font-semibold text-gray-700 dark:text-gray-300">Original Test</div>
          <div className="text-md font-semibold text-gray-700 dark:text-gray-300">Actual Test Run</div>
        </div>
        <div className="flex gap-3">
          <IconArrowsDiagonal
            size={20}
            className="cursor-pointer text-gray-700 dark:text-gray-300"
            onClick={() => setIsExpanded(!isExpanded)}
          />
          <IconX
            size={20}
            className="cursor-pointer text-gray-700 dark:text-gray-300"
            onClick={() => {
              setIsExpanded(false);
              onClose();
            }}
          />
        </div>
      </div>
      <div className="m-4 flex flex-1 gap-10 pl-4">
        <div className="flex flex-1 flex-col items-center justify-center">
          {leftOperationId ?
            <ImageView operationId={leftOperationId} />
          : <div className="flex h-full w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
              No screenshot available
            </div>
          }
        </div>
        <div className="w-[2px] bg-gray-200 dark:bg-stone-600" />
        <div className="flex flex-1 flex-col items-center justify-center">
          {rightDirectScreenshots ?
            <ImageView directScreenshots={rightDirectScreenshots} />
          : rightDirectScreenshotUrl ?
            <ImageView directScreenshotUrl={rightDirectScreenshotUrl} />
          : rightOperationId ?
            <ImageView operationId={rightOperationId} />
          : <div className="flex h-full w-full items-center justify-center text-sm text-gray-500 dark:text-gray-400">
              No screenshot available
            </div>
          }
        </div>
      </div>
    </div>
  );
}
